module.exports = __webpack_public_path__ + "media/images/awards-3-fe846be34fc033308dcad79440533ae6.jpg";